import React, { useContext, useEffect, useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Grid,
  Typography,
  Box,
  styled,
} from "@mui/material";
import { stepConnectorClasses } from "@mui/material/StepConnector";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AddCustomer from "./AddCustomer";
import UploadDoc from "./UploadDoc";
import { ConnContext } from "../../store/ConnContext";
import { useSelector } from "react-redux";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";
import AddCompanyImage from "../../../assets/Images/image 76.png";
import LeftCircle from "../../../assets/Icons/Left Circle B.png";
import RightCircle from "../../../assets/Icons/Right Circle A.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";

// ✅ Custom Connector for step line
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 0.5,
    border: 0,
    backgroundColor: "#495057", // Blue color
    borderRadius: 1,
  },
}));

// ✅ Custom step number icon
const NumberStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    ownerState.active || ownerState.completed ? "#145165" : "#FFFFFF",
  // color: "#00bcd4",
  color: ownerState.active || ownerState.completed ? "#FFFFFF" : "#495057",
  width: 35,
  height: 35,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
  fontSize: "16px",
}));

function NumberStepIcon(props) {
  const { active, completed, icon, className } = props;
  return (
    <NumberStepIconRoot
      ownerState={{ active, completed }}
      className={className}
    >
      {icon}
    </NumberStepIconRoot>
  );
}

// ✅ Stepper step labels
const stepperList = [
  {
    step: "Step 1",
    name: "Information",
  },
  {
    step: "Step 2",
    name: "Upload Documents",
  },
];

// ✅ Main component

const initialDocuments = [
  {
    id: 1,
    name: "GST Certificate",
    uploaded: false,
    editDataKey: "gstCertificateFilePath",
  },
  {
    id: 2,
    name: "Company Incorporation Certificate",
    uploaded: false,
    editDataKey: "incorporationCertificateFilePath",
  },
  {
    id: 3,
    name: "Aadhar Front Copy",
    uploaded: false,
    editDataKey: "aadharFrontFilePath",
  },
  {
    id: 4,
    name: "Aadhar Back Copy",
    uploaded: false,
    editDataKey: "aadharBackFilePath",
  },
  {
    id: 5,
    name: "Company PAN Card",
    uploaded: false,
    editDataKey: "panTanFilePath",
  },
  {
    id: 6,
    name: "Authorized Person PAN Card",
    uploaded: false,
    editDataKey: "authPersonPanFilePath",
  },
  {
    id: 7,
    name: "Board Resolution",
    uploaded: false,
    editDataKey: "boardResolutionFilePath",
  },
];
const AddCustomerTabs = ({
  CloseCreate,
  show,
  editData,
  action,
  fetchCustomerData,
  minSmsRate,
  minRcsRate,
  minRcsUtlRate,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [documents, setDocuments] = useState(initialDocuments);

  const { payloadData, setPayloadData } = useContext(ConnContext);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (action === "add") {
      // Reset form data for adding a new customer
      setPayloadData({
        username: loggedInUserName,
        name: "",
        emailId: "",
        address1: "",
        address2: "",
        address3: "",
        city: "",
        state: "",
        pinCode: "",
        firstContactPersonName: "",
        firstContactPersonMobileNo: "",
        // secondContactPersonName: '',
        // secondContactPersonMobileNo: '',
        bankName: "",
        accountNo: "",
        ifscCode: "",
        rate: "",
        rcsRate: "",
        rcsUtlRate: "",
        waMarketingRate: "",
        waUtilityRate: "",
        waAuthenticationRate: "",
        gstNumber: "",
        aadharNumber: "",
        panNumber: "",
        companyPanNumber: "",
        companyType: "",
        smsServices: true,
        rcsServices: false,
        waServices: false,
      });
    } else if (
      action === "modify" ||
      action === "view" ||
      action === "delete" ||
      action === "auth"
    ) {
      // Pre-fill the form with editData
      setPayloadData({
        ...editData,
        username: loggedInUserName,
        state: editData?.state || "",
        city: editData?.city || "",
        bankName: editData?.bankName || "",
        rcsUtlRate: editData?.rcsUtlRate ?? "",
        waMarketingRate: editData?.waMarketingRate || "",
        waUtilityRate: editData?.waUtilityRate || "",
        waAuthenticationRate: editData?.waAuthenticationRate || "",
        waServices: editData?.waServices || false,
      });
    }
  }, [action, editData]);

  const loggedInUserName = user?.data?.username;

  const handleCheckRate = async () => {
    const payload = {
      rate: payloadData?.rate,
      rcsRate: payloadData?.rcsRate,
      rcsUtlRate: payloadData?.rcsUtlRate,
      waMarketingRate: payloadData?.waMarketingRate ? Number(payloadData.waMarketingRate) * 10 : 0,
      waUtilityRate: payloadData?.waUtilityRate ? Number(payloadData.waUtilityRate) * 10 : 0,
      waAuthenticationRate: payloadData?.waAuthenticationRate ? Number(payloadData.waAuthenticationRate) * 10 : 0,
      // Include emailId only when action is "add"
      ...(action === "add" && { emailId: payloadData?.emailId }),
    };

    try {
      const response = await axiosPostApi(apiList.RATE_CHECK, payload);
      const respCode = response?.data?.respCode;

      if (response?.data?.status && respCode === "00") {
        setActiveStep((prev) => prev + 1);
      } else if (respCode === "01") {
        CustomAlert({
          title: "Failed",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      } else {
        CustomAlert({
          title: "Failed",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while processing.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const isCreateode = action === "add";
  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const isAuthMode = action === "auth";

  const isValidClick = isCreateode || isEditMode;

  const handleNext = () => {
    if (isValidClick) {
      handleCheckRate();
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleStepClick = (index) => {
    setActiveStep(index);
  };

  const getComponentByActiveStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <AddCustomer
            payloadData={payloadData}
            setPayloadData={setPayloadData}
            loggedInUserName={loggedInUserName}
            handleNext={handleNext}
            handleBack={handleBack}
            CloseCreate={CloseCreate}
            editData={editData}
            action={action}
            fetchCustomerData={fetchCustomerData}
            minSmsRate={minSmsRate}
            minRcsRate={minRcsRate}
            minRcsUtlRate={minRcsUtlRate}
          />
        );
      case 1:
        return (
          <UploadDoc
            payloadData={payloadData}
            setPayloadData={setPayloadData}
            loggedInUserName={loggedInUserName}
            CloseCreate={CloseCreate}
            editData={editData}
            action={action}
            fetchCustomerData={fetchCustomerData}
            documents={documents}
            setDocuments={setDocuments}
            initialDocuments={initialDocuments}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div
        className={`modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content w-[130%] !rounded-2xl">
            <img
              src={LeftCircle}
              alt="leftImg"
              className="absolute left-0 bottom-0 w-[110px] h-[105px]"
            />
            <img
              src={RightCircle}
              alt="leftImg"
              className="absolute right-0 top-0 w-[110px] h-[105px]"
            />
            <div className="modal-header flex justify-content-between align-items-center">
              <div className="flex items-center gap-3">
                <img
                  src={AddCompanyImage}
                  alt="add-company-img"
                  className="h-10 w-11"
                />
                <h5 className="modal-title main-title font-semibold">
                  {action.charAt(0).toUpperCase() + action.slice(1)} Company
                  Details
                </h5>
              </div>
              <img
                src={CrossIcon}
                alt="filter icon"
                className="w-[30px] h-[30px] cursor-pointer z-20"
                onClick={CloseCreate}
              />
            </div>

            <Grid item xs={12} sx={{ px: 3, pt: 2 }}>
              <div className="p-4" style={{ backgroundColor: "#e0f7fa" }}>
                <Stepper
                  alternativeLabel
                  activeStep={activeStep}
                  connector={<CustomConnector />}
                >
                  {stepperList.map((label, index) => (
                    <Step
                      key={index}
                    // onClick={() => handleStepClick(index)}
                    >
                      <StepLabel StepIconComponent={NumberStepIcon}>
                        <div className="font-poppins font-semibold text-[18px] leading-[100%] tracking-[0%] text-[#145165]">
                          {label.name}
                        </div>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </div>
            </Grid>

            <Box sx={{ p: 3 }}>{getComponentByActiveStep()}</Box>

            {/* <div className="scoped-modal modal-footer">
              <button type="button" className="btn btn-back" onClick={CloseCreate}>
                Back
              </button>
            </div> */}
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default AddCustomerTabs;
